import { useSelector } from 'react-redux';

const dispatcherValue = 'Other';
const dispatcherDispexValue = 'Own';

export const useIsDispatcher = () =>
  useSelector((state) => {
    const dispatcher = state.authentication.userInfo.Dispatcher;

    return (
      dispatcher === dispatcherDispexValue || dispatcher === dispatcherValue
    );
  });
